import React from 'react';
import { Home, Percent, ReceiptText, UserRound } from 'lucide-react';

const tabs = [
  { id: 'home', label: 'Inicio', icon: Home },
  { id: 'promos', label: 'Promos', icon: Percent },
  { id: 'orders', label: 'Pedidos', icon: ReceiptText },
  { id: 'profile', label: 'Mi perfil', icon: UserRound }
];

export default function RestaurantMobileNav({ active, onChange }) {
  return (
    <nav className="rc-mobile-nav" aria-label="Navegación del módulo de restaurantes">
      {tabs.map(({ id, label, icon: Icon }) => (
        <button type="button" key={id} className={active === id ? 'is-active' : ''} onClick={() => onChange(id)} aria-current={active === id ? 'page' : undefined}>
          <Icon aria-hidden="true" />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
